// extracted by mini-css-extract-plugin
module.exports = {"notification-reminder-wrapper":"_2yh3m","newsletter-input-wrapper":"_2WHoE","submit-btn":"_1m6tz","close-email":"_3vdM2","fadein":"uGMGl"};